import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { GlobalExclusionsDataProviderFactory } from '../factory/GlobalExclusionsDataProviderFactory';
import { XdrSearchResultsPanelBaseDataProvider } from '../dataProvider/XdrSearchResultsPanelBaseDataProvider';
import { XdrSearchResultsPanelData } from '../types';

export class XdrSearchResultsPanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: GlobalExclusionsDataProviderFactory;
  public dataProvider: XdrSearchResultsPanelBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new GlobalExclusionsDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<XdrSearchResultsPanelData> {
    return this.dataProvider.getDataForView();
  }
}
